<template>
  <div class="ratio ratio-16x9">
    <component
      :is="type"
      v-bind="$attrs"
    >
      <slot />
    </component>
  </div>
</template>

<script>
export default {
  name: 'BEmbed',
  inheritAttrs: false,
  props: {
    type: { type: String, default: 'iframe' },
    aspect: { type: String, default: '16by9' },
  },
}
</script>
